import { Component } from "@angular/core";

@Component({
  selector: "divider",
  templateUrl: "./divider.component.html",
  styleUrls: ["./divider.component.scss"],
})
export class DividerComponent {}
